import { render } from "./selectBox.vue?vue&type=template&id=15a2fa07&scoped=true"
import script from "./selectBox.vue?vue&type=script&lang=js"
export * from "./selectBox.vue?vue&type=script&lang=js"

import "./selectBox.vue?vue&type=style&index=0&id=15a2fa07&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a2fa07"]])

export default __exports__